export default __webpack_public_path__ + "static/media/flag-it.5097f0d6.svg";